import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import styles from './styles.module.css';

import SearchIcon from '../../icons/Search';
import SelectArrowsIcon from '../../icons/SelectArrows';

export default class SearchCTA extends Component {
  state = {
    searchTerm: '',
    filter: '',
  };

  updateFilter = event => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'Filter',
      eventLabel: 'homepage',
    });
    const value = event.target.value;
    this.setState({ filter: value });
  };

  updateSearchTerm = event => {
    const value = event.target.value;
    this.setState({ searchTerm: value });
  };

  search = () => {
    const { searchTerm, filter } = this.state;
    let targetPath;

    if (filter === 'MEMORY') {
      targetPath = '/memories';
    } else if (
      filter === 'GLASS' ||
      filter === 'WINDOW' ||
      filter === 'TABLEWARE'
    ) {
      targetPath = '/glass';
    } else {
      targetPath = '/search';
    }

    let query = `?term=${encodeURIComponent(searchTerm)}`;

    if (filter === 'WINDOW' || filter === 'TABLEWARE') {
      query += `&type=${filter}`;
    }

    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'Submit',
      eventLabel: 'homepage',
    });
    navigateTo(`${targetPath}${query}`);
  };

  render() {
    return (
      <div className={styles.container}>
        <label className="a11y-hide" htmlFor="search-cta-filter">
          Glass type filter
        </label>
        <div className={styles.selectContainer}>
          <select
            id="search-cta-filter"
            name="search-cta-filter"
            value={this.state.filter}
            onChange={this.updateFilter}
          >
            <option value="ALL">Everything</option>
            <option value="GLASS">All Glass</option>
            <option value="WINDOW">Glass Windows</option>
            <option value="TABLEWARE">Tableware Glass</option>
            <option value="MEMORY">Your Memories</option>
          </select>
          <div className={styles.selectArrows}>
            <SelectArrowsIcon size={16} />
          </div>
        </div>
        <label className="a11y-hide" htmlFor="search-cta-term">
          Search term
        </label>
        <input
          type="text"
          id="search-cta-term"
          name="search-cta-term"
          placeholder="Enter a search term"
          value={this.state.searchTerm}
          onChange={this.updateSearchTerm}
        />
        <button onClick={this.search}>
          <SearchIcon size={16} />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search-cta/index.js